export default function ({ ...props }) {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.0281 9.86739H16.3784C16.7217 9.86739 17 10.161 17 10.5231C17 10.6428 16.969 10.7602 16.9102 10.8626L10.6897 21.71C10.5268 21.994 10.1765 22.085 9.90722 21.9131C9.70245 21.7824 9.59692 21.5307 9.64306 21.2829L10.9724 14.1447H6.62158C6.27829 14.1447 6 13.8511 6 13.4889C6 13.3693 6.03099 13.252 6.08962 13.1497L12.3112 2.29026C12.474 2.00614 12.8243 1.91503 13.0936 2.08676C13.2984 2.21738 13.4041 2.46915 13.358 2.71694L12.0281 9.86739Z"
                stroke="#010101"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
        </svg>
    );
}
